import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertBody, AlertDescription, AlertIcon, BeakerOutline, Heading, HStack, SimpleGrid, Text, VStack } from '@bonusly/design-system';

import { ContentContainer } from '../../../components/layout/content-container';
import { SampleExperiment } from '../experiments/sample-experiment';
import { VideoConferencing1on1Experiment } from '../experiments/video-conferencing-1on1';

export const LabsApp: FC = () => {
	const { t } = useTranslation('labs');

	return (
		<ContentContainer as="main" data-testid="labs-page">
			<VStack align="stretch" spacing={6}>
				<VStack align="stretch" spacing={2}>
					<HStack spacing={3} align="center">
						<BeakerOutline size="lg" />
						<Heading size="lg">{t('title')}</Heading>
						<Text as="span" bg="points.bgAlpha" color="points.fg" px={2} py={0.5} borderRadius="full" fontSize={100} fontWeight="semibold">
							{t('alphaLabel')}
						</Text>
					</HStack>
					<Text color="text.softer">{t('subtitle')}</Text>
				</VStack>

				<Alert status="info">
					<AlertIcon />
					<AlertBody>
						<AlertDescription>{t('employeesOnlyBanner')}</AlertDescription>
					</AlertBody>
				</Alert>

				<SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
					<SampleExperiment />
					<VideoConferencing1on1Experiment />
				</SimpleGrid>
			</VStack>
		</ContentContainer>
	);
};
